import { useState, useLayoutEffect, RefObject } from 'react';

import ResizeObserver from 'resize-observer-polyfill';

type Bounds = {
  width: number;
  height: number;
};

/**
 * Gets the measure of an element using `ResizeObserver`
 * @param ref Element to be measured
 * @returns an object containing `width` and `height` for the element passed as ref (without padding)
 * @see AnimateHeight Tabs WorkflowBar
 */
export default function useMeasure(ref: RefObject<Element>) {
  const [bounds, setBounds] = useState<Bounds>({
    width: 0,
    height: 0,
  });

  useLayoutEffect(() => {
    if (!ref.current) return undefined;

    function onResize([entry]: ResizeObserverEntry[]) {
      setBounds({
        height: entry.contentRect.height,
        width: entry.contentRect.width,
      });
    }

    const observer = new ResizeObserver(onResize);
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return bounds;
}
